import API from '../../api/endpoints'
import event from '../../event'
export default {
  methods: {
    doCalculations (lookupId) {
      return new Promise((resolve, reject) => {
        this.$http.put(API.UPDATE_LINE_CALCULATIONS(lookupId))
        .then(({data}) => {
          resolve(data)
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/helpers/CalculatedFieldsMixin.js